import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit} from '@angular/core';
import {GEOSERVER_URL} from '../shared/tokens';
import * as L from 'leaflet';
import {CapMeldung} from '../shared/domain/cap-meldung';
import {CapMeldungArea} from '../shared/domain/cap-meldung-area';
import { CapMeldungParameter } from '../shared/domain/cap-meldung-parameter';

@Component({
    selector: 'sim-map',
    templateUrl: './map.component.html'
})

export class MapComponent implements OnInit, AfterViewInit {

    // Leaflets elements
    private map?: L.Map;
    private readonly drawingsLayer = L.featureGroup();

    private viewInitialized: boolean;

    private capMeldungArea?:
        | CapMeldungArea
        | null
    ;

    constructor(private readonly elementRef: ElementRef,
                @Inject(GEOSERVER_URL) private readonly geoServerUrl: string) {
        this.viewInitialized = false;
    }

    ngAfterViewInit(): void {
        this.viewInitialized = true;
    }

    ngOnInit(): void {
        const tileLayer = L.tileLayer(this.geoServerUrl, {maxZoom: 16, minZoom: 8});

        const item: HTMLDivElement = this.elementRef.nativeElement.querySelector('div#map');

        const map = L.map(item, {center: L.latLng(46.81, 8.2), zoom: 8, attributionControl: false});
        this.drawingsLayer.addTo(map);

        tileLayer.addTo(map);

        this.map = map;

        this.map.scrollWheelZoom.disable();

        this.drawArea();
    }

    @Input()
    public set currentData(meldung: CapMeldung) {
        console.log('setCurrentData');
        this.capMeldungArea = null;
        if (meldung.alert.info != null) {
            if (meldung.alert.info[0].area != null) {
                // handle only area of first language info (info[0])
                this.capMeldungArea = meldung.alert.info[0].area[0];
            }
        }

        if (this.viewInitialized) {
            this.drawArea();
        }
    }

    private drawArea(): void {
        // Clear drawings
        if (this.drawingsLayer) {
            this.drawingsLayer.clearLayers();
        }

        // Draw content
        const { capMeldungArea } = this;
        if (capMeldungArea != null) {
            if (capMeldungArea.circle != null) {
                capMeldungArea.circle.forEach(item => {
                    const coords = (item.match(/\d+(?:[.])\d+/g) as RegExpMatchArray).map(Number);
                    const drawnCircle = L.circle(L.latLng(coords[0], coords[1]), coords[2] * 1000).addTo(this.map as L.Map);
                    this.addToDrawingLayer(drawnCircle);
                });
            }
            if (capMeldungArea.polygon != null) {
                let index = 0;

                capMeldungArea.polygon.forEach(item => {
                    const polygons: L.LatLngExpression[][] = [];

                    // shell
                    polygons.push(this.convertPolygonPoints(item.split(' ')));

                    // check for holes
                    (capMeldungArea.geocode as CapMeldungParameter[]).forEach(geocode => {
                        if (geocode.valueName === 'ALERTSWISS_EXCLUDE_POLYGON') {
                            const hole = geocode.value.split('|');
                            if (index.toString() === hole[0]) {
                                polygons.push(this.convertPolygonPoints(hole[1].split(' ')));
                            }
                        }
                    });

                    this.addToDrawingLayer(L.polygon(polygons));

                    index++;
                });
            }

            // Zoom to drawings
            if (capMeldungArea.circle != null || capMeldungArea.polygon != null) {
                (this.map as L.Map).fitBounds(this.drawingsLayer.getBounds());
            }
        }

    }

    private convertPolygonPoints(points: string[]): L.LatLngExpression[] {
        const output: L.LatLngExpression[] = [];
        points.forEach(point => {
            const coords = (point.match(/\d+(?:[.])\d+/g) as RegExpMatchArray).map(Number);
            output.push({lat: coords[0], lng: coords[1]});
        });
        return output;
    }

    private addToDrawingLayer(
        layer:
            | L.Circle
            | L.Polygon
        ,
    ): void {
        layer.setStyle({
            color: 'steelblue'
        });
        this.drawingsLayer.addLayer(layer);
    }

}
